import StageOne from "./component";
import StageOneContainer from "./container";

export { StageOne, StageOneContainer };
export default StageOneContainer;



// WEBPACK FOOTER //
// ./client/modules/ReportForm/components/StageOne/index.ts